import React, { useState, Fragment } from "react"
import { useTranslation } from "react-i18next"
import { SketchPicker } from "react-color"
import { useDispatch } from "react-redux"
import { documentsActions } from "../../actions/documentsActions"

const ColorPickerForm = ({ color, setColor, nombre, setNombre, verColorPicker, setVerColorPicker, lista, setLista, id, setId, setTag }) => {
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const [isValidTag, setIsValidTag] = useState(false)
	const [isValidColorCode, setIsValidColorCode] = useState(false)
	/* ******************** CUSTOM FUNCTIONS ******************** */

	const validateColorCode = (colorCode) => {
		const REGEX = /^#[0-9A-F]{6}$/i
		return REGEX.test(colorCode)
	}

	const validateTagName = (tagName) => {
		const REGEX = /^[A-Za-z0-9]+$/
		return REGEX.test(tagName)
	}

	const setCustomTag = (priority, color) => {
		dispatch(documentsActions.setPriorityCustomTagAction(priority, color, null))
	}
	const handleSubmit = (e) => {
		e.preventDefault()

		if (nombre && color) {
			//const rand = (Math.random() + 1).toString(36).substring(7);
			setId(null)

			//Enviar al servidor

			// Objeto lista
			const objetoLista = {
				name: nombre,
				color: color,
				id: null,
			}
			//Copia lo que hay en el array lista y añade el objetoLista
			setLista([...lista, objetoLista])
			setTag(objetoLista)

			//Reinicia el formulario
			setNombre("")
			setColor("")
			setVerColorPicker(false)
		} else if (!nombre && !color) {
			alert(t("alert-txt-one"))
		} else if (!nombre) {
			alert(t("alert-txt-two"))
		} else if (!color) {
			alert(t("alert-txt-three"))
		}

		setCustomTag(nombre, color)
	}
	/* ******************** END CUSTOM FUNCTIONS ******************** */

	return (
		<Fragment>
			<div className="row">
				<fieldset className="form-group">
					{/* <legend>Guarda etiquetas con colores</legend> */}
					<form onSubmit={handleSubmit}>
						<div className="form-group">
							{/* <label class="form-label" >Tag name: </label> */}
							<input
								className="form-control"
								name="nombre"
								type="text"
								placeholder={t("tag.placeholder1")}
								value={nombre}
								onChange={(e) => {
									setNombre(e.target.value)
								}}
								onBlur={(e) => {
									setNombre(e.target.value?.trim())
								}}
								maxLength={100}
							/>
						</div>
						<div className="form-group">
							{/* <label class="form-label">Pick color: </label> */}
							<input
								className="form-control"
								name="color"
								type="text"
								value={color}
								placeholder={t("tag.placeholder2")}
								onChange={(e) => {
									setColor(e.target.value)
									validateColorCode(e.target.value) ? setIsValidColorCode(true) : setIsValidColorCode(false)
								}}
								onClick={() => setVerColorPicker((verColorPicker) => !verColorPicker)}
							/>
						</div>
						{verColorPicker && (
							<SketchPicker
								nombre={nombre}
								color={color}
								onChange={(cambiarColor) => {
									setColor(cambiarColor.hex)
									validateColorCode(cambiarColor.hex) ? setIsValidColorCode(true) : setIsValidColorCode(false)
								}}
							/>
						)}
						<button disabled={!isValidColorCode || !color || !nombre} className="btn btn-primary mt-5" type="submit">
							{t("tag.button-text")}
						</button>
					</form>
				</fieldset>
			</div>
		</Fragment>
	)
}

export default ColorPickerForm
